




import Vue from "vue";
import SamlAuthentication from "@/components/authentication/saml-authentication.component.vue";
export default Vue.extend({
  components: {
    "saml-authentication": SamlAuthentication,
  },
});
